/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonTrxDetailInfo } from '../models/BabylonTrxDetailInfo';
import type { BabylonTrxListInfo } from '../models/BabylonTrxListInfo';
import type { BabylonTrxLogEventListInfo } from '../models/BabylonTrxLogEventListInfo';
import type { BabylonTrxLogListInfo } from '../models/BabylonTrxLogListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonTrxControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns BabylonTrxDetailInfo OK
     * @throws ApiError
     */
    public getTrxDetail1({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<BabylonTrxDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/transaction',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns BabylonTrxListInfo OK
     * @throws ApiError
     */
    public getBabylonTrxScrollList({
        size = 25,
        lastVal,
    }: {
        size?: number,
        lastVal?: number,
    }): CancelablePromise<BabylonTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/transaction/scroll/list',
            query: {
                'size': size,
                'lastVal': lastVal,
            },
        });
    }

    /**
     * @returns BabylonTrxLogEventListInfo OK
     * @throws ApiError
     */
    public getBabylonTrxLogMessageList({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<BabylonTrxLogEventListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/transaction/log/message/list',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns BabylonTrxLogListInfo OK
     * @throws ApiError
     */
    public getBabylonTrxLogList({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<BabylonTrxLogListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/transaction/log/list',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns BabylonTrxLogEventListInfo OK
     * @throws ApiError
     */
    public getBabylonTrxLogEventList({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<BabylonTrxLogEventListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/transaction/log/event/list',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns BabylonTrxListInfo OK
     * @throws ApiError
     */
    public getTransactionList2({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/transaction/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

}
